import type { Routes } from '../../shares/types';
import { SkipNavBasic } from './basic';

export const SKIP_NAV_ROUTES: Routes = {
	'skip-nav': {
		basic: SkipNavBasic,
	},
};
